export default {
  namespaced: true,
  state: {
    content: {
      showroom: {
        title: 'Шоу-рум LITHIUM',
        address: 'Вятка - Киров, Казанская 77б',
        schedule: [
          'ПН-ПТ 10.00-19.00',
          'СБ 10.00-17.00',
          'ВС Выходной'
        ],
        phone: [ '8(8332) 711-887' ],
        coords: [ 58.602782, 49.683750 ]
      },
      footer: [
        {
          key: '',
          title: '',
          value: 'MADE IN RUSSIA, Vyatka - Kirov'
        },
        {
          key: '',
          title: '',
          value: '© Lithium ' + new Date().getFullYear()
        }
      ]
    }
  },
  getters: {
    content (state) {
      return state.content
    }
  }
}
